import { themes } from "../MatxTheme/initThemes";
import layout1Settings from "./Layout1/Layout1Settings";
import layout2Settings from "./Layout2/Layout2Settings";

// UPDATE BELOW CODE
// DOC http://demos.ui-lib.com/matx-react-doc/layout.html
export const MatxLayoutSettings = {
  activeLayout: "layout1", // Change this to 'layout1' for layout1, 'layout2' for layout2
  // Global active theme used by MatxTheme (controls palette for pages outside layout wrappers)
  // To use the slate dark look across the app (including session pages), set this to "slateDark1".
  activeTheme: "blue", // View all valid theme colors inside MatxTheme/themeColors.js
  perfectScrollbar: true,

  themes: themes,

  // Conditional settings based on active layout
  layout1Settings, // You can add settings for layout1 here
  layout2Settings, // You can add settings for layout2 here

  // Setting the layout dynamically
  getCurrentLayoutSettings() {
    if (this.activeLayout === "layout1") {
      return this.layout1Settings;
    }
    return this.layout2Settings;
  },

  getSidebarSettings() {
    const layoutSettings = this.getCurrentLayoutSettings();
    return layoutSettings.leftSidebar;
  },

  // secondarySidebar settings for both layouts
  secondarySidebar: {
    show: false,
    open: false,
    theme: "whiteBlue", // View all valid theme colors inside MatxTheme/themeColors.js
  },

  // Footer options for both layouts
  footer: {
    show: true,
    fixed: true,
    theme: "whiteBlue", // View all valid theme colors inside MatxTheme/themeColors.js
  },
};
